import { inject } from "@angular/core";
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
  HttpContext,
} from "@angular/common/http";

import { ToastService } from "src/app/shared/services/toast.service";
import { TranslateService } from "@ngx-translate/core";
import { Observable, tap } from "rxjs";
import { HttpContextToken } from "@angular/common/http";

export interface ToastContext {
  message?: string;
  severity?: "success" | "error" | "warning" | "info";
  duration?: number;
}

export const TOAST_CONTEXT = new HttpContextToken<ToastContext>(() => ({}));
const NoShowToast = new HttpContextToken<boolean>(() => false);
export const NoShowToastContext = () => {
  return { context: new HttpContext().set(NoShowToast, true) };
};
export const httpToastInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const toast = inject(ToastService);
  const translate = inject(TranslateService);
  const context = req.context.get(TOAST_CONTEXT);
  const noToastContext = req.context.get(NoShowToast);
  return next(req).pipe(
    tap({
      next: (event) => {
        if (event instanceof HttpResponse) {
          if (["POST", "PUT", "DELETE"].includes(req.method)) {
            if (noToastContext) {
              return;
            }
            const message =
              context.message ||
              translate.instant("messages.operation_success");
            const duration = context.duration || 2000;
            const severity = context.severity || "success";
            if (severity === "success")
              toast.success(message, undefined, duration);
            else if (severity === "info")
              toast.info(message, undefined, duration);
            else if (severity === "warning")
              toast.warning(message, undefined, duration);
            else if (severity === "error")
              toast.error(message, undefined, duration);
          }
        }
      },
      // error: (_error: HttpErrorResponse) => {
      //   // Don't show toast for 409 errors (conflict - FNSKU already exists)
      //   if (_error.status === 409) {
      //     return;
      //   }
      //   // Always display a translated message with error severity
      //   const message = translate.instant("messages.Unexpected error occurred");
      //   const duration = 2000;
      //   // Toast Escape hatch for specific cases
      //   if (noToastContext) {
      //     return;
      //   }
      //   toast.error(message, "Error", duration);
      // },
    }),
  );
};
